import QRCode from 'qrcode'
import { BrowserQRCodeReader } from '@zxing/browser'

export interface PaymentQRData {
  type: 'payment' | 'menu'
  amount?: string
  orderId?: string
}

export class QRService {
  private reader: BrowserQRCodeReader

  constructor() {
    this.reader = new BrowserQRCodeReader()
  }

  async generateQR(data: PaymentQRData | string): Promise<string> {
    try {
      const qrData = typeof data === 'string' ? data : JSON.stringify(data)
      return await QRCode.toDataURL(qrData)
    } catch (error) {
      console.error('Error generating QR code:', error)
      throw error
    }
  }

  async scanQR(
    videoElement: HTMLVideoElement
  ): Promise<PaymentQRData | string> {
    try {
      const result = await this.reader.decodeOnceFromVideoElement(videoElement)
      const text = result.getText()

      try {
        // Try to parse as PaymentQRData
        const parsed = JSON.parse(text)
        if (typeof parsed === 'object' && 'type' in parsed) {
          return parsed as PaymentQRData
        }
      } catch {
        // If parsing fails, treat as plain text (wallet address)
        return text
      }

      throw new Error('Invalid QR code format')
    } catch (error) {
      console.error('Error scanning QR code:', error)
      throw error
    }
  }

  stopScanning() {
    // Clean up without using reset
    this.reader = new BrowserQRCodeReader()
  }
}

export const qrService = new QRService()
